var exports = {
  "kL": "x04b3a21e--024733--container",
  "iq": "x04b3a21e--024733--image-container",
  "DD": "x04b3a21e--024733--title",
  "h_": "x04b3a21e--024733--description",
  "x6": "x04b3a21e--024733--button",
};

module.exports = exports;
